import { Button } from '@shared/components';
import { useFeedContext } from '@shared/plugin/contexts/FeedContext';
import { FeedTimeline } from '@shared/plugin/features/Feed';
import { FeedItemType } from '@shared/plugin/features/Feed/types';
import { EmailThreadActivity } from '@shared/plugin/pages/Home/components/email-thread-activity';
import { NavigateToShipment } from '@shared/plugin/pages/Home/components/NavigateToShipment';
import { ACTIVITY_ROUTE } from 'clerk_common/constants/urls/routes';
import { useState } from 'react';
import {
  PiArrowsOutSimpleBold,
  PiCaretDownBold,
  PiCaretUpBold,
} from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';

export function EmailThreadFeedSection() {
  const {
    feed: { items },
  } = useFeedContext();
  const [isExpanded, setIsExpanded] = useState(true);
  const navigate = useNavigate();

  const activityCount = items.filter(
    (item) => item.type !== FeedItemType.EMPTY_STATE
  ).length;
  if (activityCount === 0) return null;

  return (
    <section
      aria-label="This email"
      className="flex max-h-[30%] shrink-0 flex-col border-t border-gray-200 bg-gray-50"
    >
      <div className="flex flex-row items-center gap-1 pr-2">
        <div className="flex-1">
          <Button
            aria-expanded={isExpanded}
            isGhost
            size="small"
            icon={
              isExpanded ? (
                <PiCaretDownBold size={12} />
              ) : (
                <PiCaretUpBold size={12} />
              )
            }
            iconPosition="right"
            onPress={() => setIsExpanded((isOpen) => !isOpen)}
            className="w-full justify-between text-gray-600"
          >
            {`This email · ${activityCount}`}
          </Button>
        </div>
        <Button
          aria-label="Open Activity"
          icon={<PiArrowsOutSimpleBold size={14} />}
          isGhost
          onPress={() => navigate(ACTIVITY_ROUTE)}
          size="xs"
          tooltip="Open Activity"
        />
      </div>
      {isExpanded && (
        <>
          <NavigateToShipment />
          <EmailThreadActivity />
          <FeedTimeline className="relative min-h-0 px-2" />
        </>
      )}
    </section>
  );
}
